<template>
  <div class="email-attachments">
    <div v-if="withDefaultAttachment" class="row justify-between q-mt-lg q-mb-md">
      <RCheckbox v-model="includeDefault" label="Include default attachment" @input="handleDefaultAttachment($event)" />

      <q-btn
        v-if="includeDefault"
        flat
        round
        size="xs"
        @click="$emit('download-default-attachment', { name: 'default', system_generated: true })"
      >
        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12.9425 7.25H11.75V3.5C11.75 3.0875 11.4125 2.75 11 2.75H8C7.5875 2.75 7.25 3.0875 7.25 3.5V7.25H6.0575C5.39 7.25 5.0525 8.06 5.525 8.5325L8.9675 11.975C9.26 12.2675 9.7325 12.2675 10.025 11.975L13.4675 8.5325C13.94 8.06 13.61 7.25 12.9425 7.25ZM4.25 14.75C4.25 15.1625 4.5875 15.5 5 15.5H14C14.4125 15.5 14.75 15.1625 14.75 14.75C14.75 14.3375 14.4125 14 14 14H5C4.5875 14 4.25 14.3375 4.25 14.75Z"
            fill="#269AE4"
          />
        </svg>
      </q-btn>
    </div>

    <template v-for="(attachment, index) of attachments">
      <div
        v-if="!(attachment.name === 'default' && attachment.system_generated)"
        :key="generateAttachmentKey(attachment, index)"
        class="row attachment justify-between q-mt-sm q-mb-md"
      >
        <label class="col trim limited">
          <i class="fas fa-paperclip q-mr-sm" />
          <span class="q-pl-sm">{{ attachment.name }}</span>
        </label>

        <TrashIcon class="q-mr-xs" @click.native="deleteAttachment(index)" />
      </div>
    </template>

    <small>
      <label class="stakeholder-helper text-tertiary cursor-pointer relative-position q-mt-md">
        <input
          ref="uploader"
          style="height: 20px"
          type="file"
          class="q-input q-uploader-input cursor-pointer absolute visually-hidden"
          multiple
          @input="prepareFiles($event)"
        />
        <Grid gaf="column" justify-content="start" gap="var(--r-space-sm)">
          <PlusIcon />
          <div class="text-body-1 text-secondary-1">Add attachment</div>
        </Grid>
      </label>
    </small>
  </div>
</template>

<script>
// Components
import TrashIcon from '@/ui/icons/TrashIcon'
import PlusIcon from '@/ui/icons/PlusIcon'

export default {
  name: 'EmailAttachments',

  components: {
    TrashIcon,
    PlusIcon
  },

  props: {
    withDefaultAttachment: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      includeDefault: true,
      attachments: []
    }
  },
  watch: {
    attachments(newVal) {
      this.$emit('attachments-updated', newVal)
    }
  },
  created() {
    if (this.includeDefault && this.withDefaultAttachment) this.addDefaultAttachment()
  },
  methods: {
    handleDefaultAttachment(e) {
      e ? this.addDefaultAttachment() : this.removeDefaultAttachment()
    },
    prepareFiles() {
      let files = []
      for (let i = 0; i < this.$refs.uploader.files.length; i++) {
        const file = this.$refs.uploader.files[i]
        files.push({
          name: file.name,
          system_generated: false,
          file: file
        })
      }
      files = this.attachments.concat(files)
      this.$set(this, 'attachments', files)
    },
    addDefaultAttachment() {
      this.attachments.push({
        name: 'default',
        system_generated: true,
        file: null
      })
    },
    removeDefaultAttachment() {
      let index = this.attachments.findIndex(file => file.name === 'default' && file.system_generated)
      this.attachments.splice(index, 1)
    },
    deleteAttachment(index) {
      this.attachments.splice(index, 1)
      this.$refs.uploader.value = ''
    },
    generateAttachmentKey(attachment, index) {
      return `email_attachment_${attachment.name}_${index}`
    },
    resetEmailAttachments() {
      this.$set(this, 'attachments', [])
      if (this.includeDefault && this.withDefaultAttachment) this.addDefaultAttachment()
    }
  }
}
</script>

<style lang="stylus">
.visually-hidden {
  position: absolute !important;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
}
&.limited {
  max-width: 230px !important;
  &.trim {
    .lm-checkbox {
      max-width: 100% !important;
    }
    .q-option-label {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
</style>
